/**
 * steps/WorkflowIntroduction.tsx
 * Workflow introduction step for the onboarding wizard
 *
 * Brief transition screen between risk configuration and basic settings.
 * Explains what's next without overwhelming the user.
 */

// 1. External dependencies
import React, { useEffect } from 'react';

// 2. Internal absolute imports
import { Card, CardBody, CardHeader } from '@enfomentis/ui';

// 3. Relative imports
import { useOnboardingData } from '../hooks/useOnboardingData';

/**
 * Workflow Introduction component
 * Uses main wizard navigation instead of card-level buttons
 */
export const WorkflowIntroduction: React.FC = () => {
  const { markCompleted } = useOnboardingData();

  // Mark this screen as complete when component mounts
  useEffect(() => {
    markCompleted('workflow-intro');
  }, [markCompleted]);

  return (
    <Card
      radius="none"
      shadow="none"
      className="h-full max-h-[100dvh] w-full flex flex-col border-0"
    >
      <CardBody className="flex-1 flex items-center justify-center p-6">
        <Card className="w-full max-w-2xl">
          <CardHeader className="pb-3 text-2xl font-bold border-b-1">
            Almost Done with Setup!
          </CardHeader>
          <CardBody className="pt-6 pb-6">
            <div className="space-y-4 text-base leading-relaxed text-text-secondary pt-2">
              <div>
                Great progress! You've configured your <span className="text-text-primary font-semibold">account</span>, <span className="text-text-primary font-semibold">trading strategy</span>, and <span className="text-text-primary font-semibold">risk management</span>.
              </div>
              <div>
                To finish onbaording, we'll set up your <span className="text-primary font-semibold">basic preferences</span>—timezone and trading schedule.
              </div>
              <div>
                More detailed workflow settings will be configured as you engage with your trading hub.
              </div>
            </div>
          </CardBody>
        </Card>
      </CardBody>
    </Card>
  );
};
